import type { factures as Fr } from '../fr/factures';

/** « factures » in English — typed on the French: a missing sentence does not compile. */
export const factures: typeof Fr = {
  erreur: 'Error',
  titre: 'Invoices',
  sousTitre: 'Tamper-proof sequential numbering — an issued invoice is never modified',
  emettre: 'Issue an invoice',
  vide: 'No invoices issued',
  colNumero: 'No.', colDate: 'Date', colType: 'Type', colClient: 'Customer', colContrat: 'Agreement', colTotal: 'Total incl. tax',
  types: { acompte: 'down payment', solde: 'final', avoir: 'credit note' } as Record<string, string>,
  dontTva: (pct: number | undefined) => `incl. VAT ${pct}%`,
  dejaVerse: (m: string) => `already paid ${m}`,
  imprimer: 'Print',
  explication: 'The invoice is built from the rental agreement: rental, check-out extra charges, check-in extra charges, minus what has already been collected.',
  avecTva: 'Invoice with VAT',
  avecTvaAide: '— tick for a company, untick for an individual paying at the counter',
  solde: (m: string) => `balance due ${m}`,
  btnAcompte: 'Down payment',
  btnSolde: 'Final',
};
